import Vue from "vue";

const url = "wss://6ln0zorhdd.execute-api.us-east-2.amazonaws.com/dev";
let socket;

const emitter = new Vue({
  methods: {
    send(message) {
      if(!socket){
        this.connect();
        setTimeout(() => {
          if (1 === socket.readyState) socket.send(message);
        }, 2000)
      } else {
        if (1 === socket.readyState) socket.send(message);
      }
    },
    close() {
      if (socket && 1 === socket.readyState) {
        emitter.$emit("message", "ClosingSocket");
        socket.close();
        socket = null;
      }
    },
    connect(username) {
      socket = new WebSocket(url);
      socket.onmessage = function(msg) {
        console.log(`WS: message received`);
        emitter.$emit("message", msg.data);
      };
      socket.onerror = function(err) {
        console.log('WS: error');
        emitter.$emit("error", err);
      };
      socket.onclose = function(msg) {
        console.log('WS: close: ' + new Date().toString());
        emitter.$emit("close", msg);
      };
      //emitter.$emit("message", "Opening Socket.");
      
      if(username !== "Anonymous"){
        var scope = this;
        setTimeout(function(){
          if(socket.readyState === 1){
            scope.send(JSON.stringify({
              action: "setUsername",
              username: username
            }));
          }
        }, 2000);
      }
    },
    getState () {
      if(!socket)
      {
        return 0;
      } else {
        return socket.readyState;
      }
    }
  }
});

//emitter.connect('Anonymous');

export default emitter;